import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Hub } from 'aws-amplify/utils';
import { LoadingSpinner } from '../components/common';

// Per shared-docs/apple-sign-in.md: Amplify v6 emits 'signedIn' / 'signInWithRedirect_failure'.
// The 15s timeout (vs 5s) accommodates slow first-load token exchanges on cellular.
export default function OAuthCallbackPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const listener = Hub.listen('auth', ({ payload }) => {
      if (payload.event === 'signedIn') navigate('/', { replace: true });
      if (payload.event === 'signInWithRedirect_failure') navigate('/auth/login', { replace: true });
    });
    const timeout = setTimeout(() => navigate('/auth/login', { replace: true }), 15000);
    return () => { listener(); clearTimeout(timeout); };
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-night-bg safe-area-top safe-area-bottom flex flex-col items-center justify-center px-4">
      <div className="text-center">
        <LoadingSpinner size="lg" />
        <h1 className="text-xl font-semibold text-gray-900 dark:text-night-text mt-4">Signing you in…</h1>
        <p className="text-sm text-gray-500 dark:text-night-muted mt-1">Please wait while we complete sign in.</p>
      </div>
    </div>
  );
}
